export default class PlayerDeactivatedException extends Error {
  readonly status: number = 410;

  constructor() {
    super('The player has been deactivated.');
    this.name = 'PlayerDeactivatedException';
  }
}
